import React from 'react';

import { FieldWrapperStyled } from './FieldWrapper.styled';

export const FieldWrapper = ({
  children,
  size,
}: {
  children: any;
  size: string;
}) => {
  return <FieldWrapperStyled size={size}>{children}</FieldWrapperStyled>;
};
